/**
 * This enum is only used to control whether we are showing the user the map or the gallery.
 * It is saved as a preference of theirs so they will always come back to their previous setting.
 * @export
 * @enum {number}
 */
export enum ViewModes {
  MAP,
  GALLERY
}

export enum DrawerModes {
  CLOSED,
  FILTERS,
  OVERLAYS,
  SAVE_SEARCH,
  SEARCH_FILTERS
}

export enum SortBy {
  NEWEST = 1,
  OLDEST = 2,
  PRICE_LOW_TO_HIGH = 3,
  PRICE_HIGH_TO_LOW = 4
}

export enum MyRemaxModes {
  FAVOURITES = 'favourites',
  SAVED_SEARCHES = 'saved-searches',
  MANAGE_NOTIFICATIONS = 'manage-notifications'
}

export enum MarkerType {
  SCHOOL,
  LISTING,
  PLAIN,
  OFFICE
}

export enum MapStyle {
  SCHOOLS,
  POI,
  COMPARABLES
}

export enum SocialType {
  NotSocial,
  Facebook,
  Google
}

export enum PaymentsFrequency {
    Default,
    Weekly,
    RapidWeekly,
    BiWeekly,
    RapidBiWeekly,
    Monthly
}

export enum ListingType {
  SingleFamily = 100,
  Commercial = 101,
  VacantLand = 102,
  Rental = 103,
  CondoTownhome = 104,
  MultiFamily = 105,
  Farm = 106,
  BusinessOpportunity = 107,
  HotelResort = 108,
  PrivateIsland = 109,
  AuctionItem = 110,
  CommercialLease = 112,
  PocketListing = 113,
  Timeshare = 120,
  MobileHome = 121,
  ManufacturedHome = 122,
  Lease = 130,
  ToBeBuilt = 140,
  VacationRental = 150,
  DockSlip = 151,
  Duplex = 155,
  Condo = 160,
  Townhome = 161,
  NewHomeCommunities = 170,
  NewHomePlans = 171,
  Acreage = 180,
  Agricultural = 181,
  Recreational = 182
}

export class ListingTypeMap {
  static condo: Array<ListingType> = [ ListingType.CondoTownhome, ListingType.Condo ];
  static house: Array<ListingType> = [ ListingType.SingleFamily, ListingType.Duplex ];
  static land: Array<ListingType> = [ ListingType.VacantLand, ListingType.Acreage ];
  static farm: Array<ListingType> = [ ListingType.Farm, ListingType.Agricultural ];
  static townhouse: Array<ListingType> = [ ListingType.CondoTownhome, ListingType.Townhome ];
  static recreational: Array<ListingType> = [ ListingType.PrivateIsland, ListingType.Timeshare, ListingType.VacationRental, ListingType.Recreational ];
  static mobileHome: Array<ListingType> = [ ListingType.MobileHome ];
  // Commercial is complicated, it includes land and farm, which we also show as residential.
  static commercial: Array<ListingType> = [ ListingType.Commercial,
                                            ListingType.BusinessOpportunity,
                                            ListingType.HotelResort,
                                            ListingType.CommercialLease,
                                            ListingType.VacantLand,
                                            ListingType.Farm,
                                            ListingType.Agricultural ];

  // Used to remove explicit commercial types from residential and luxury.
  // Differs from 'commercial' above because we don't want to exclude VacantLand, Acreage, Farm and Agricultural from Residential/Luxury
  static excludeCommercial: Array<ListingType> = [
    ListingType.Commercial,
    ListingType.BusinessOpportunity,
    ListingType.HotelResort,
    ListingType.CommercialLease
  ];

  // this is needed in case the user is filtering individual commercial items
  static businessOpportunity: Array<ListingType> = [ListingType.BusinessOpportunity ];
  static commercialLease: Array<ListingType> = [ListingType.CommercialLease ];
  static hotelResort: Array<ListingType> = [ListingType.HotelResort ];
  static vacantLand: Array<ListingType> = [ListingType.VacantLand];
}

export enum SCREEN_SIZE {
  MOBILE_ONLY,
  TABLET_PORTRAIT_UP,
  TABLET_LANDSCAPE_UP,
  DESKTOP_UP,
  BIG_DESKTOP_UP
}

export enum ListingCategory {
  RESIDENTIAL,
  LUXURY,
  COMMERCIAL
}

export enum ListingPurchase {
  RENTAL,
  SALE
}

export enum ListPriceMove {
  UNKNOWN,
  UP,
  DOWN
}

export enum UpdatedSince {
  ANY = 0,
  YESTERDAY = 1,
  LASTWEEK = 2,
  LASTMONTH = 3,
}

export enum SearchType {
  OFFICE = 'OFFICE',
  AGENT = 'AGENT'
}

export enum BlogPostSourcePage {
  HomePage,
  ListingPage
}

export enum ContactFormLocationType {
  LISTING_CONTACT_AGENT,
  LISTING_SCHEDULE_VIEWING,
  LISTING_ASK_QUESTION,
  AGENT_PAGE_CONTACT,
  OFFICE_PAGE_CONTACT,
  LISTING_ASK_QUESTION_OFFMARKET,
  LISTING_OFFMARKET_CONTACT_AGENT
}

export enum PersonaType {
  FIRST_TIME_BUYER_SINGLE,
  FIRST_TIME_BUYER_COUPLE,
  MOVING_UP,
  EMPTY_NESTERS,
  LUXURY,
  MULTI_GENERATIONAL_FAMILY
}

export enum SavedSearchLocationType {
  SAVED_SEARCHES,
  SAVE_SEARCH,
}

export enum NotificationFrequency {
  DAILY = 0,
  WEEKLY = 1,
  MONTHLY = 2,
  REALTIME = 3,
}
export const victoriaRealEstate = 'victoria real estate';

export enum CommercialListingTypes {
  businessOpportunity = 'businessOpportunity',
  commercial = 'commercial',
  farm = 'farm',
  hotelResort = 'hotelResort',
  commercialLease = 'commercialLease',
  vacantLand = 'vacantLand'
};

export enum DirectoryTypes {
  LISTING,
  OPEN_HOUSE,
  AGENT,
  NEIGHBOURHOOD
};

export enum LoginSource {
  Generic = 'generic',
  HomeEstimator = 'homeEstimator',
  Radar = 'radar'
};


export enum LoginStates {
  EnterEmail,
  Login,
  SignUp,
  ForgotPassword
};

export enum ListingSource {
  CREA = "63144"
}
